import { WellsIcon } from '../icons'

export default {
  id: 'wells',
  title: {
    en: 'Wells',
    ar: 'الآبار'
  },
  Icon: WellsIcon,
  description: {
    en: `<p>A well is a structure created in the ground by digging, driving, or drilling to access groundwater in underground aquifers.</p><p>Jordan has more than 661 governmental wells with a productivity of more than 330 million cubic meters per year.</p>`,
    ar: ``
  },
  entries: [
    {
      id: 'well01',
      title: { en: 'Irbid', ar: 'اربد' },
      numberOfWells: '98',
      productivity: '55,619,623',
      position: { x: '461.6', y: '261.4' }
    },
    {
      id: 'well02',
      title: { en: 'Ajloun', ar: 'عجلون' },
      numberOfWells: '5',
      productivity: '758,648',
      position: { x: '440.8', y: '344.2' }
    },
    {
      id: 'well03',
      title: { en: 'Jarash', ar: 'جرش' },
      numberOfWells: '20',
      productivity: '4,619,212',
      position: { x: '517', y: '360' }
    },
    {
      id: 'well04',
      title: { en: 'Mafraq', ar: 'المفرق' },
      numberOfWells: '111',
      productivity: '34,557,255',
      position: { x: '608', y: '329' }
    },
    {
      id: 'well05',
      title: { en: 'Zarqa', ar: 'الزرقاء' },
      numberOfWells: '59',
      productivity: '40,763,674',
      position: { x: '640', y: '435' }
    },
    {
      id: 'well06',
      title: { en: 'Amman', ar: 'عمان' },
      numberOfWells: '31',
      productivity: '14,614,877',
      position: { x: '534', y: '483' }
    },
    {
      id: 'well07',
      title: { en: 'Balqa', ar: 'البلقاء' },
      numberOfWells: '38',
      productivity: '9,464,371',
      position: { x: '455', y: '461' }
    },
    {
      id: 'well08',
      title: { en: 'Madaba', ar: 'مادبا' },
      numberOfWells: '18',
      productivity: '11,003,747',
      position: { x: '436', y: '594' }
    },
    {
      id: 'well09',
      title: { en: 'Karak', ar: 'الكرك' },
      numberOfWells: '104',
      productivity: '23,438,860',
      position: { x: '437', y: '832' }
    },
    {
      id: 'well10',
      title: { en: 'Tafila', ar: 'الطفيلة' },
      numberOfWells: '21',
      productivity: '6,821,491',
      position: { x: '416', y: '989' }
    },
    {
      id: 'well11',
      title: { en: 'Aqaba', ar: 'العقبة' },
      numberOfWells: '88',
      productivity: '119,317,423',
      position: { x: '196', y: '1357' }
    },
    {
      id: 'well12',
      title: { en: "Ma'an", ar: 'معان' },
      numberOfWells: '68',
      productivity: '15,671,049',
      position: { x: '441', y: '1181' }
    }
  ]
}
